import React, { useEffect } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { UserX, LogOut } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";

export default function UserDeactivated() {
  const { logout } = useAuth();

  useEffect(() => {
    const timer = setTimeout(() => logout(), 3000);
    return () => clearTimeout(timer);
  }, [logout]);

  const handleLogout = () => logout();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 p-6">
      <Card className="max-w-md w-full shadow-xl">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <UserX className="w-8 h-8 text-red-600" />
          </div>
          <div>
            <CardTitle className="text-2xl text-slate-900">Acesso Desativado</CardTitle>
            <CardDescription className="text-base mt-2">
              Sua conta foi temporariamente desativada
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          <p className="text-slate-600">
            Entre em contato com o administrador do sistema para reativar seu acesso.
          </p>
          <div className="pt-4">
            <Button 
              onClick={handleLogout}
              className="w-full bg-slate-900 hover:bg-slate-800"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Sair do Sistema
            </Button>
          </div>
          <p className="text-xs text-slate-500">
            Você será desconectado automaticamente em alguns segundos...
          </p>
        </CardContent>
      </Card>
    </div>
  );
}